"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagKeys = void 0;
exports.FeatureFlagKeys = {
    UNIFIED_BILLING: 'UNIFIED_BILLING',
    UNIFIED_DISPATCH_VIEW: 'unified-dispatch-view',
    WAYSTE_EDITABLE_TERMS_OF_SERVICE: 'wayste-editable-terms-of-service',
    LIFTLINE: 'liftline',
    ROLL_OFF_MIGRATION_PHASE_2: 'roll-off-migration-phase-2',
    ROLL_OFF_CALENDAR_VIEW: 'roll-off-calendar-view',
    EVENTS: 'events',
    JUNK_AND_HEAVY_MATERIALS: 'junk-and-heavy-materials',
};
//# sourceMappingURL=feature-flags.js.map